import * as Checkbox from "@radix-ui/react-checkbox";
import * as Label from "@radix-ui/react-label";

import { CheckIcon } from "@radix-ui/react-icons";
import { Comedian } from "@punchup/data/legacy";
import SuggestedComedianAvatar from "../SuggestedComedianAvatar";
import { getComedianInitials } from "@punchup/utils/getComedianInitials";
import { useId } from "react";

interface Props {
  comedian: Comedian;
  comedianImageUrl: string;
  loading: boolean;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

export default function ComedianCheckboxRow({
  comedian: { id, display_name: displayName, about },
  comedianImageUrl,
  loading,
  checked,
  onCheckedChange,
}: Props) {
  const inputId = useId();

  return (
    <Label.Root
      className="flex flex-row items-center justify-between w-full gap-4 px-3 py-[14px] text-lg text-gray-900 transition-colors duration-200 ease-in-out rounded-md md:my-2 group hover:bg-neutral-50 active:bg-neutral-100 hover:cursor-pointer"
      htmlFor={inputId}
    >
      <SuggestedComedianAvatar
        fallbackText={getComedianInitials(displayName)}
        displayName={displayName ?? undefined}
        imageSrc={comedianImageUrl}
      />
      <div className={`flex-1 font-sans mr-2 ${loading ? "opacity-50" : ""}`}>
        <h2 className="overflow-hidden text-[16px] font-medium leading-normal text-left text-ellipsis whitespace-nowrap">
          {displayName}
        </h2>
        <p className="text-[14px] leading-tight line-clamp-2 text-ellipsis text-neutral-400 font-light">
          {about}
        </p>
      </div>
      <div>
        <Checkbox.Root
          name="selectedComedians"
          id={inputId}
          value={id}
          disabled={loading}
          checked={checked}
          onCheckedChange={onCheckedChange}
          className="flex items-center justify-center transition-colors duration-200 ease-in-out border rounded-md shadow-sm disabled:opacity-50 bg-neutral-50 border-neutral-200 w-7 h-7 checked:border-primary focus:ring-orange-50 focus:ring aria-checked:border-primary"
        >
          <Checkbox.Indicator className="bg-primary/90 text-neutral-100 text-xl stroke-neutral-100 h-full w-full rounded-[5px] flex flex-col justify-center items-center">
            <CheckIcon height={20} width={20} strokeWidth={1.2} />
          </Checkbox.Indicator>
        </Checkbox.Root>
      </div>
    </Label.Root>
  );
}
